export default __webpack_public_path__ + "static/media/discord.46413c87.svg";